import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Renders an admin-managed HTML module by name.
 * The server resolves {loadtag: 1,8,12} shortcodes into tag pills.
 * The "modules_global_css" stylesheet is served via the app-wide
 * /api/custom-css.css external stylesheet (scoped to .content-module).
 * Renders nothing when the module is missing or empty.
 */
const ContentModule = ({ name, className = '' }) => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/content-modules/${name}`);
        if (!cancelled) setHtml((data.module && data.module.html) || '');
      } catch (_) {
        if (!cancelled) setHtml('');
      }
    })();
    return () => { cancelled = true; };
  }, [name]);

  if (!html) return null;
  return (
    <div
      className={`content-module ${className}`}
      data-testid={`content-module-${name}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default ContentModule;
